
export default {
  data() {
    return {
      approachItems: [],

      options: [
        {
          name: "title",
          label: "Naslov",
          type: "text",
        },
        {
          name: "show",
          label: "Trebate oznacit!*",
          type: "checkbox",
        },
      ],
    };
  },

  mounted() {
    setTimeout(() => {
      if (
        this.$refs.approach &&
        this.$refs.approach.items &&
        this.$refs.approach.items.length
      ) {
        this.approachItems = this.$refs.approach.items;
        if (this.approachItems.length > 0) {
          this.approachItems.forEach((item) => (item.show = false));
          this.approachItems[0].show = true;
        }
      }
    }, 300);

    setInterval(async () => {
      const sleep = (time) =>
        new Promise((resolve) => setTimeout(resolve, time));

      var index = this.approachItems.findIndex((item) => item.show);

      if (index + 1 === this.approachItems.length) {
        index = -1;
      }

      this.approachItems.forEach((item) => (item['show'] = false));

      await sleep(500);

      this.approachItems[index + 1]['show'] = true;

      await sleep(1000);
    }, 2000);

    window.addEventListener("scroll", this.startAnimation, {
      passive: true,
    });
  },

  methods: {
    addActiveClass(e) {
      if (window.innerWidth > 1080) {
        const el = e.currentTarget;
        el.classList.add("active");
      }
    },
    removeActiveClass(e) {
      if (window.innerWidth > 1080) {
        const el = e.currentTarget;
        el.classList.remove("active");
      }
    },

    startAnimation() {
      if (window.innerWidth <= 1080) {
        let activeId = document.getElementById("our-approach");
        if (!activeId) return;

        const sectionTop = activeId.getBoundingClientRect();
        const sectionHeight = activeId.clientHeight;

        if (sectionHeight >= sectionTop.y + 300) {
          activeId.classList.add("active");
        } else activeId.classList.remove("active");
      }
    },
  },
};
